module.exports = __webpack_public_path__ + "img/749DCBE9905D3847.4c81512f.png";